/* OVREL core — loaded on every page (deferred).
   Dialogs, header, cart drawer, events, signup, recently viewed.
   No dependencies. Template-specific code lives in ov-product.js,
   ov-collection.js, ov-search.js (lazy) and ov-finder.js (lazy). */
(function () {
  'use strict';
  var OV = (window.OV = window.OV || {});
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  OV.$ = $; OV.$$ = $$;

  /* ---------------------------------------------------------- storage */
  function store(kind) {
    var mem = {};
    var s = kind === 'session' ? 'sessionStorage' : 'localStorage';
    return {
      get: function (k) { try { var v = window[s].getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return mem[k] || null; } },
      set: function (k, v) { mem[k] = v; try { window[s].setItem(k, JSON.stringify(v)); } catch (e) {} }
    };
  }
  OV.local = store('local');
  OV.session = store('session');

  /* ------------------------------------------------------------ money */
  OV.money = function (cents) {
    var n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: OV.currency || 'USD', minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return '$' + (n % 1 ? n.toFixed(2) : n); }
  };

  OV.announce = function (msg) {
    var el = document.getElementById('ov-live');
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 30);
  };

  OV.device = function () {
    var w = window.innerWidth;
    return w < 750 ? 'mobile' : w < 1100 ? 'tablet' : 'desktop';
  };

  /* ---------------------------------------------------- attribution */
  var ATTR_KEY = 'ov:attr';
  function attribution() {
    var existing = OV.session.get(ATTR_KEY);
    var q = new URLSearchParams(location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var found = {}, has = false;
    keys.forEach(function (k) { if (q.get(k)) { found[k] = q.get(k); has = true; } });
    ['gclid', 'fbclid', 'ttclid', 'epik', 'msclkid'].forEach(function (k) { if (q.get(k)) { found.click = k; has = true; } });
    if (existing && !has) return existing;
    var ref = '';
    try { if (document.referrer && new URL(document.referrer).hostname !== location.hostname) ref = new URL(document.referrer).hostname; } catch (e) {}
    var a = {
      source: found.utm_source || (existing && existing.source) || (ref ? ref : 'direct'),
      medium: found.utm_medium || (existing && existing.medium) || (ref ? 'referral' : 'none'),
      campaign: found.utm_campaign || (existing && existing.campaign) || '',
      content: found.utm_content || (existing && existing.content) || '',
      term: found.utm_term || (existing && existing.term) || '',
      click: found.click || (existing && existing.click) || '',
      landing: (existing && existing.landing) || location.pathname,
      referrer: (existing && existing.referrer) || ref
    };
    OV.session.set(ATTR_KEY, a);
    return a;
  }
  OV.attr = attribution();

  /* ----------------------------------------------------------- events
     Published to Shopify Customer Events as `ovrel_<name>` (a Custom Pixel
     forwards them; see docs/redesign/ANALYTICS.md) and to dataLayer.
     Standard ecommerce events are NOT re-sent from here: Shopify's
     channel pixels already send them and a second copy double counts. */
  OV.track = function (name, props) {
    var payload = Object.assign({
      page_type: OV.template,
      device: OV.device(),
      source: OV.attr.source,
      medium: OV.attr.medium,
      campaign: OV.attr.campaign,
      creative: OV.attr.content,
      term: OV.attr.term,
      landing_page: OV.attr.landing,
      currency: OV.currency
    }, window.OV_EXP ? { experiments: window.OV_EXP } : {}, props || {});
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('ovrel_' + name, payload);
      }
    } catch (e) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'ovrel_' + name }, payload));
    /* GA4 (only when the theme's GA4 id is set and consent allows): flat params, custom names only */
    if (window.OV_GA4 && typeof window.gtag === 'function') {
      var flat = {};
      Object.keys(payload).forEach(function (k) {
        var v = payload[k];
        flat[k] = v && typeof v === 'object' ? JSON.stringify(v).slice(0, 100) : v;
      });
      try { window.gtag('event', 'ovrel_' + name, flat); } catch (e) {}
    }
    if (window.ovrelSettingsDebug || (OV.debug)) console.log('[ovrel]', name, payload);
  };

  /* ------------------------------------------------------- dialogs */
  var openStack = [];
  OV.openDialog = function (dlg, opener) {
    if (!dlg || dlg.open) return;
    dlg._opener = opener || document.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.body.classList.add('ov-lock');
    openStack.push(dlg);
    var auto = dlg.querySelector('[autofocus], input[type=search], input[type=email]');
    if (auto && dlg.id !== 'ov-signup') setTimeout(function () { auto.focus(); }, 30);
  };
  OV.closeDialog = function (dlg) {
    if (!dlg || !dlg.open) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  };
  function onDialogClosed(dlg) {
    openStack = openStack.filter(function (d) { return d !== dlg; });
    if (!openStack.length) document.body.classList.remove('ov-lock');
    if (dlg._opener && document.contains(dlg._opener)) { try { dlg._opener.focus(); } catch (e) {} }
    dlg.dispatchEvent(new CustomEvent('ov:closed'));
  }
  $$('dialog.ov-dialog').forEach(function (dlg) {
    dlg.addEventListener('close', function () { onDialogClosed(dlg); });
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-ov-close]')) { OV.closeDialog(dlg); return; }
      if (e.target === dlg) {
        var r = dlg.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside || dlg.classList.contains('ov-signup')) {
          if (!inside) OV.closeDialog(dlg);
        }
      }
    });
  });

  /* ------------------------------------------------------- header */
  var header = $('[data-ov-header]');
  if (header) {
    // Over the homepage mosaic the header sits transparent on the artwork and docks as a
    // paper bar (.is-stuck) once the hero has scrolled away. Without this script it simply
    // scrolls off with the hero, which is still usable.
    var mosaic = $('[data-ov-mosaic]');
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
      if (mosaic) header.classList.toggle('is-stuck', mosaic.getBoundingClientRect().bottom <= header.offsetHeight);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var panels = $$('[data-ov-panel]', header);
    var closeTimer;
    var closeAll = function (except) {
      panels.forEach(function (b) {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });
      header.classList.toggle('is-open', !!except);
    };
    var openPanel = function (b) {
      clearTimeout(closeTimer);
      closeAll(b);
      b.setAttribute('aria-expanded', 'true');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = false;
      header.classList.add('is-open');
    };
    panels.forEach(function (b) {
      b.addEventListener('click', function (e) {
        /* pointing opens the panel, so the click that follows must not close it again */
        if (b._hoverOpened && Date.now() - b._hoverOpened < 800) { b._hoverOpened = 0; return; }
        if (b.getAttribute('aria-expanded') === 'true') { closeAll(); return; }
        openPanel(b);
        /* opened from the keyboard: move into the panel instead of tabbing past four tools */
        if (e.detail === 0) {
          var first = document.getElementById(b.getAttribute('aria-controls'));
          first = first && first.querySelector('a, button');
          if (first) setTimeout(function () { first.focus(); }, 30);
        }
      });
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        b.addEventListener('mouseenter', function () { if (b.getAttribute('aria-expanded') !== 'true') b._hoverOpened = Date.now(); openPanel(b); });
      }
    });
    header.addEventListener('mouseleave', function () {
      if (!window.matchMedia('(hover: hover)').matches) return;
      closeTimer = setTimeout(closeAll, 180);
    });
    header.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('is-open')) {
        var open = panels.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0];
        closeAll();
        if (open) open.focus();
      }
    });
    header.addEventListener('focusout', function (e) {
      if (!header.contains(e.relatedTarget)) closeAll();
    });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAll(); });
  }

  /* menu disclosures (also reused by any [data-ov-disclose]) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ov-disclose]');
    if (!b) return;
    var t = document.getElementById(b.getAttribute('aria-controls'));
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (t) t.hidden = open;
  });

  /* openers */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ov-open]');
    if (!o) return;
    var kind = o.getAttribute('data-ov-open');
    if (kind === 'cart' && OV.template === 'cart') return;
    e.preventDefault();
    if (kind === 'menu') OV.openDialog($('#ov-menu'), o);
    if (kind === 'search') OV.search.open(o);
    if (kind === 'cart') OV.cart.open(o);
  });

  /* --------------------------------------------------------- search */
  OV.search = {
    loaded: false,
    open: function (opener) {
      var dlg = $('#ov-search');
      if (!dlg) { location.href = OV.routes.search; return; }
      var menu = $('#ov-menu'); if (menu && menu.open) OV.closeDialog(menu);
      OV.openDialog(dlg, opener);
      if (!this.loaded) {
        this.loaded = true;
        var s = document.createElement('script');
        s.src = OV.assets.search; s.defer = true;
        document.head.appendChild(s);
      }
    }
  };

  /* ----------------------------------------------------------- cart */
  var drawer = $('#ov-cart');
  function sectionIds() {
    var ids = ['ov-cart-drawer'];
    var page = $('[data-ov-cart-section]');
    if (page) ids.push(page.getAttribute('data-ov-cart-section'));
    return ids;
  }
  function cartState() {
    var t = $('#ov-cart-title');
    return { count: t ? +t.getAttribute('data-count') : 0, total: t ? +t.getAttribute('data-total') : 0 };
  }
  function applySections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    var active = document.activeElement;
    var activeKey = active && (active.getAttribute('data-ov-qty') || active.getAttribute('data-ov-remove')) ? active.outerHTML : null;
    if (sections['ov-cart-drawer']) {
      var doc = parser.parseFromString(sections['ov-cart-drawer'], 'text/html');
      var inner = doc.getElementById('ov-cart-inner');
      var cur = document.getElementById('ov-cart-inner');
      if (inner && cur) cur.innerHTML = inner.innerHTML;
    }
    var page = $('[data-ov-cart-section]');
    if (page) {
      var id = page.getAttribute('data-ov-cart-section');
      if (sections[id]) {
        var d2 = parser.parseFromString(sections[id], 'text/html');
        var n = d2.querySelector('[data-ov-cart-section]');
        if (n) page.innerHTML = n.innerHTML;
      }
    }
    var st = cartState();
    $$('[data-ov-cart-count]').forEach(function (el) { el.textContent = '(' + st.count + ')'; });
    $$('[data-ov-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Bag, ' + st.count + ' items'); });
    /* controls that triggered the update were replaced; keep keyboard focus inside the drawer */
    if (drawer && drawer.open && (activeKey || drawer._refocus)) {
      drawer._refocus = false;
      var title = $('#ov-cart-title'); if (title) { title.setAttribute('tabindex', '-1'); title.focus(); }
    }
    OV.rv.render();
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      /* Decide by the body, not the header: Shopify answers the .js cart endpoints with
         content-type text/javascript, so a header test mistook every successful add for a
         bot challenge and the form fallback added the work a second time (v36–v37).
         Bot protection or a 429 answers with an HTML page, which does not parse. */
      return r.text().then(function (text) {
        var j;
        try { j = JSON.parse(text); } catch (e) {
          var busyErr = new Error('The shop is busy for a moment. Please try again.');
          busyErr.notJson = true; busyErr.status = r.status;
          throw busyErr;
        }
        if (!r.ok) { var err = new Error(j.description || j.message || 'Cart error'); err.data = j; throw err; }
        return j;
      });
    });
  }
  /* last resort for an add the JSON API refused: the normal form post, which also lets a shopper pass a challenge */
  function formAdd(items) {
    var f = document.createElement('form');
    f.method = 'post'; f.action = OV.routes.cartAdd; f.hidden = true;
    items.forEach(function (it, i) {
      var add = function (name, value) { var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = name; inp.value = value; f.appendChild(inp); };
      add('items[' + i + '][id]', it.id);
      add('items[' + i + '][quantity]', it.quantity || 1);
      Object.keys(it.properties || {}).forEach(function (k) { add('items[' + i + '][properties][' + k + ']', it.properties[k]); });
    });
    document.body.appendChild(f);
    f.submit();
  }
  function afterChange(before) {
    var after = cartState();
    if (OV.threshold && before.total < OV.threshold && after.total >= OV.threshold) {
      OV.track('free_shipping_reached', { cart_total: after.total / 100 });
    }
  }
  var attrWritten = OV.session.get('ov:attr-written');
  function writeAttribution() {
    if (attrWritten) return;
    attrWritten = true; OV.session.set('ov:attr-written', true);
    var a = OV.attr;
    post(OV.routes.cartUpdate + '.js', { attributes: {
      _ov_source: a.source, _ov_medium: a.medium, _ov_campaign: a.campaign, _ov_content: a.content,
      _ov_click: a.click, _ov_landing: a.landing, _ov_referrer: a.referrer, _ov_device: OV.device()
    } }).catch(function () {});
  }

  OV.cart = {
    open: function (opener) {
      if (!drawer) { location.href = OV.routes.cart; return; }
      if (drawer.open) return;
      OV.openDialog(drawer, opener);
      OV.track('cart_view', { items: cartState().count, cart_total: cartState().total / 100 });
    },
    /* items: [{id, quantity, properties?}]; meta: {source, handles, pair} */
    add: function (items, meta) {
      meta = meta || {};
      var before = cartState();
      return post(OV.routes.cartAdd + '.js', { items: items, sections: sectionIds().join(','), sections_url: location.pathname })
        .catch(function (err) {
          if (err.notJson) { formAdd(items); return new Promise(function () {}); }
          throw err;
        })
        .then(function (res) {
          applySections(res.sections);
          afterChange(before);
          writeAttribution();
          var lines = (res.items || []).map(function (i) {
            return { handle: i.handle, variant_id: i.variant_id, size: i.options_with_values && i.options_with_values[0] ? i.options_with_values[0].value : null, frame: i.options_with_values && i.options_with_values[1] ? i.options_with_values[1].value : null, format: i.options_with_values && i.options_with_values[1] ? (/unframed/i.test(i.options_with_values[1].value) ? 'paper_print' : 'framed_print') : null, price: i.final_price / 100, quantity: i.quantity };
          });
          OV.track('add_to_cart', { source: meta.source || 'unknown', lines: lines, value: lines.reduce(function (s, l) { return s + l.price * l.quantity; }, 0) });
          if (meta.pair) OV.track('add_pair_to_cart', { pair: meta.pair, source: meta.source, handles: lines.map(function (l) { return l.handle; }), lines: lines, value: lines.reduce(function (s, l) { return s + l.price * l.quantity; }, 0) });
          if (meta.open !== false) OV.cart.open(meta.opener || (document.activeElement !== document.body ? document.activeElement : null));
          OV.announce(items.length > 1 ? 'Added ' + items.length + ' works to your bag' : 'Added to your bag');
          return res;
        });
    },
    change: function (key, qty, meta) {
      var before = cartState();
      return post(OV.routes.cartChange + '.js', { id: key, quantity: qty, sections: sectionIds().join(','), sections_url: location.pathname })
        .then(function (res) {
          applySections(res.sections);
          afterChange(before);
          if (qty === 0) { OV.track('remove_from_cart', meta || {}); OV.announce('Removed from your bag'); }
          return res;
        });
    },
    swap: function (fromId, toId, qty) {
      var updates = {}; updates[fromId] = 0; updates[toId] = qty;
      var before = cartState();
      return post(OV.routes.cartUpdate + '.js', { updates: updates, sections: sectionIds().join(','), sections_url: location.pathname })
        .then(function (res) { applySections(res.sections); afterChange(before); OV.track('select_frame', { source: 'cart_upsell', variant_id: toId }); OV.announce('Frame added'); });
    }
  };

  function busy(btn, on) { if (!btn) return; btn.setAttribute('aria-busy', on ? 'true' : 'false'); btn.disabled = !!on; }
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'ov-toast'; t.setAttribute('role', 'alert'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 4200);
  }
  OV.toast = toast;

  document.addEventListener('click', function (e) {
    if (drawer && drawer.contains(e.target) && e.target.closest('button')) drawer._refocus = true;
    var q = e.target.closest('[data-ov-qty]');
    if (q) { busy(q, true); OV.cart.change(q.getAttribute('data-ov-qty'), parseInt(q.getAttribute('data-ov-qty-to'), 10)).catch(function (err) { toast(err.message); busy(q, false); }); return; }
    var r = e.target.closest('[data-ov-remove]');
    if (r) { busy(r, true); OV.cart.change(r.getAttribute('data-ov-remove'), 0, { handle: r.getAttribute('data-ov-handle') }).catch(function (err) { toast(err.message); busy(r, false); }); return; }
    var a = e.target.closest('[data-ov-add]');
    if (a) {
      busy(a, true);
      var addPair = a.getAttribute('data-ov-pair-name');
      var addItem = { id: +a.getAttribute('data-ov-add'), quantity: 1 };
      if (addPair) addItem.properties = { _pair: addPair.slice(0, 80) };
      OV.cart.add([addItem], { source: a.getAttribute('data-ov-source') || 'button', pair: addPair || undefined })
        .catch(function (err) { toast(err.message); }).then(function () { busy(a, false); });
      return;
    }
    var p = e.target.closest('[data-ov-add-pair]');
    if (p) {
      busy(p, true);
      var pairName = p.getAttribute('data-ov-pair-name') || '';
      /* _pair travels into the order (hidden at checkout), so pair rate and
         pair AOV are measured from orders, not inferred from events. */
      var ids = p.getAttribute('data-ov-add-pair').split(',').map(function (x) { return { id: +x, quantity: 1, properties: { _pair: pairName.slice(0, 80) } }; });
      OV.cart.add(ids, { source: p.getAttribute('data-ov-source') || 'pair', pair: pairName })
        .catch(function (err) { toast(err.message); }).then(function () { busy(p, false); });
      return;
    }
    var s = e.target.closest('[data-ov-swap-from]');
    if (s) { busy(s, true); OV.cart.swap(+s.getAttribute('data-ov-swap-from'), +s.getAttribute('data-ov-swap-to'), +s.getAttribute('data-ov-swap-qty')).catch(function (err) { toast(err.message); busy(s, false); }); return; }
    var c = e.target.closest('[data-ov-checkout]');
    if (c) { var st = cartState(); OV.track('begin_checkout', { items: st.count, cart_total: st.total / 100 }); }
  });
  /* configurable pairs: per-work size/frame → frame preview, total, shipping, button */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ov-pair-select]');
    if (!sel) return;
    var pair = sel.closest('[data-ov-pair-config]');
    var sels = $$('[data-ov-pair-select]', pair);
    var total = 0, ids = [];
    sels.forEach(function (s) {
      var o = s.options[s.selectedIndex];
      total += +o.getAttribute('data-price');
      ids.push(s.value);
      var piece = $('[data-ov-pair-piece="' + s.getAttribute('data-ov-pair-select') + '"] .ov-frame', pair);
      if (piece) piece.setAttribute('data-frame', o.getAttribute('data-frame'));
    });
    $('[data-ov-pair-total]', pair).textContent = OV.money(total);
    var ship = $('[data-ov-pair-ship]', pair);
    if (ship) ship.hidden = total < +ship.getAttribute('data-threshold');
    $('[data-ov-add-pair]', pair).setAttribute('data-ov-add-pair', ids.join(','));
  });

  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-ov-qty-input]');
    if (!i) return;
    var v = Math.max(0, parseInt(i.value, 10) || 0);
    OV.cart.change(i.getAttribute('data-ov-qty-input'), v).catch(function (err) { toast(err.message); });
  });

  /* ------------------------------------------- room compositor (client)
     Mirrors snippets/ov-room.liquid. opts: {room, rooms, img, w, h, frame} */
  OV.room = {
    FRAME_IN: 0.85,
    update: function (el, opts) {
      if (!el) return;
      opts = opts || {};
      var d = el.dataset;
      if (opts.room && opts.rooms && opts.room !== d.ovRoom) {
        var cfg = opts.rooms.filter(function (r) { return r.key === opts.room; })[0];
        if (cfg) {
          var plate = el.querySelector('.ov-room__plate');
          if (plate && cfg.src) { plate.srcset = cfg.srcset; plate.src = cfg.src; }
          d.ovRoom = cfg.key; d.ppi = cfg.ppi; d.cx = cfg.cx; d.by = cfg.by;
        }
      }
      if (opts.w) d.w = opts.w;
      if (opts.h) d.h = opts.h;
      if (opts.frame) d.frame = opts.frame;
      var ppi = +d.ppi, cx = +d.cx, by = +d.by, w = +d.w, h = +d.h;
      var f = d.frame === 'unframed' ? 0 : this.FRAME_IN;
      var boxW = w + 2 * f, boxH = h + 2 * f;
      var art = el.querySelector('.ov-room__art');
      var frame = el.querySelector('.ov-room__art .ov-frame');
      if (art) {
        art.style.left = (cx / 9.28) + '%';
        art.style.top = (by / 11.52) + '%';
        art.style.width = (boxW * ppi / 9.28) + '%';
      }
      if (frame) {
        frame.setAttribute('data-frame', d.frame);
        frame.style.setProperty('--frame', (f / boxW * 100) + '%');
      }
      if (opts.img && art) {
        var im = art.querySelector('img');
        if (im && im.getAttribute('src') !== opts.img) { im.removeAttribute('srcset'); im.src = opts.img; }
      }
      this.crop(el);
    },
    crop: function (el) {
      var d = el.dataset, r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var ratio = r.width / r.height;
      var vis = 1 / (ratio * (1152 / 928));
      var f = d.frame === 'unframed' ? 0 : this.FRAME_IN;
      var focus = (+d.by - (+d.h + 2 * f) * +d.ppi / 2) / 1152;
      var c = Math.max(0, Math.min(1 - vis, focus - vis / 2));
      if (vis >= 1) c = 0;
      el.style.setProperty('--crop-m', (-c * 100) + '%');
      el.style.setProperty('--crop-d', (-c * 100) + '%');
    }
  };
  $$('[data-ov-room]').forEach(function (el) { OV.room.crop(el); });
  var roomResize;
  window.addEventListener('resize', function () {
    clearTimeout(roomResize);
    roomResize = setTimeout(function () { $$('[data-ov-room]').forEach(function (el) { OV.room.crop(el); }); }, 120);
  });

  /* home room viewer */
  $$('[data-ov-viewer]').forEach(function (v) {
    var data; try { data = JSON.parse($('script[type="application/json"]', v).textContent); } catch (e) { return; }
    var roomEl = $('[data-ov-room]', v);
    var used = false;
    function mark(kind) { if (!used) { used = true; OV.track('room_visualizer', { placement: 'home', control: kind }); } }
    v.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ov-viewer-art]');
      var r = e.target.closest('[data-ov-viewer-room]');
      if (t) {
        var item = data.items[+t.getAttribute('data-ov-viewer-art')];
        $$('[data-ov-viewer-art]', v).forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
        OV.room.update(roomEl, { img: item.img, w: item.w, h: item.h });
        var cap = $('[data-ov-viewer-caption]', v);
        if (cap) cap.innerHTML = '<a class="ov-link" href="' + item.url + '">' + OV.escape(item.title) + '</a> · ' + OV.escape(item.size) + ' · from ' + OV.escape(item.price);
        mark('artwork');
      }
      if (r) {
        $$('[data-ov-viewer-room]', v).forEach(function (b) { b.setAttribute('aria-pressed', b === r ? 'true' : 'false'); });
        OV.room.update(roomEl, { room: r.getAttribute('data-ov-viewer-room'), rooms: data.rooms });
        mark('room');
      }
    });
  });

  /* ---------------------------------------------- card hover images */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('.ov-card');
      if (!card || card._hov) return;
      card._hov = true;
      var alt = card.querySelector('[data-ov-hover]');
      if (!alt) return;
      var img = new Image();
      img.alt = ''; img.decoding = 'async';
      img.src = alt.getAttribute('data-ov-hover');
      img.onload = function () { alt.appendChild(img); };
    });
  }

  /* ------------------------------------------------ select_item */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.ov-card__link');
    if (!link) return;
    var card = link.closest('.ov-card');
    OV.track('select_item', { handle: card.getAttribute('data-ov-item'), list: card.getAttribute('data-ov-list') || OV.template, position: +card.getAttribute('data-ov-pos') || null });
  });

  /* ------------------------------------------- recently viewed */
  OV.rv = {
    key: 'ov:rv',
    push: function (item) {
      var list = (OV.local.get(this.key) || []).filter(function (x) { return x.h !== item.h; });
      list.unshift(item);
      OV.local.set(this.key, list.slice(0, 12));
    },
    render: function () {
      var slots = $$('[data-ov-rv]');
      if (!slots.length) return;
      var current = OV.context && OV.context.item ? OV.context.item.handle : null;
      var list = (OV.local.get(this.key) || []).filter(function (x) { return x.h !== current; }).slice(0, 6);
      slots.forEach(function (slot) {
        var wrap = slot.closest('[data-ov-rv-wrap]') || slot;
        if (list.length < 2) { wrap.hidden = true; return; }
        slot.innerHTML = list.map(function (x) {
          return OV.cardHtml({ t: x.t, u: x.u, price: x.p, sheet: x.k, framed: x.i, list: 'recently_viewed' });
        }).join('');
        wrap.hidden = false;
      });
    }
  };
  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  OV.escape = escapeHtml;

  /* The product card for lists built in the browser (search, finder, recently viewed).
     Same markup and rule as snippets/ov-card.liquid: the artwork sheet leads and the
     framed render is the hover; without a sheet the framed render is the picture. */
  OV.cardHtml = function (o) {
    var e = escapeHtml, media;
    if (o.sheet) {
      media = '<div class="ov-card__media ov-card__media--sheet"><div class="ov-card__art"><img src="' + e(o.sheet) + '" alt="' + e(o.t) + '" loading="lazy" decoding="async"></div>' +
        (o.framed ? '<div class="ov-card__alt ov-card__alt--framed" aria-hidden="true" data-ov-hover="' + e(o.framed) + '"></div>' : '') + '</div>';
    } else {
      media = '<div class="ov-card__media ov-card__media--framed"><div class="ov-card__framed"><img src="' + e(o.framed) + '" alt="' + e(o.t) + ', framed" loading="lazy" width="300" height="300"></div></div>';
    }
    return '<article class="ov-card"' + (o.handle ? ' data-ov-item="' + e(o.handle) + '"' : '') + (o.list ? ' data-ov-list="' + e(o.list) + '"' : '') + (o.pos ? ' data-ov-pos="' + o.pos + '"' : '') + '>' + media +
      '<div class="ov-card__info"><h3 class="ov-card__title">' + e(o.t) + '</h3><p class="ov-card__price">' + e(o.price) + '</p></div>' +
      '<a class="ov-card__link" href="' + e(o.u) + '" aria-label="' + e(o.t) + ', ' + e(o.price) + '"></a></article>';
  };
  OV.rv.render();

  /* -------------------------------------------------------- signup */
  (function signup() {
    var dlg = $('#ov-signup');
    var KEY = 'ov:signup';
    var state = OV.local.get(KEY) || {};
    var now = Date.now();
    var DAY = 864e5;

    /* returning from checkout: suppress for 30 days */
    try {
      if (/\/checkouts?\/|\/thank[_-]you|\/orders\//.test(document.referrer)) { state.purchasedAt = now; OV.local.set(KEY, state); }
    } catch (e) {}

    /* footer / modal success after a normal POST */
    if (/customer_posted=true/.test(location.search)) {
      state.subscribed = true; OV.local.set(KEY, state);
      OV.track('newsletter_signup', { placement: 'footer' });
    }

    if (!dlg) return;
    var pv = (OV.session.get('ov:pv') || 0) + 1; OV.session.set('ov:pv', pv);
    var desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var blocked = state.subscribed || OV.subscribed ||
      (state.closedAt && now - state.closedAt < 30 * DAY) ||
      (state.purchasedAt && now - state.purchasedAt < 30 * DAY) ||
      OV.template === 'cart' || OV.template === 'search' || OV.template === 'password' ||
      /* never interrupt a phone mid-decision on a product page, or anyone with a bag */
      (!desktopPointer && OV.template === 'product') || cartState().count > 0 ||
      /[?&](utm_medium=email|customer_posted)/.test(location.search);
    if (blocked) return;

    var arm = 'editorial';
    if (dlg.getAttribute('data-mode') === 'test' && dlg.getAttribute('data-incentive') === '1') {
      arm = OV.local.get('ov:exp:signup');
      if (!arm) { arm = Math.random() < 0.5 ? 'editorial' : 'incentive'; OV.local.set('ov:exp:signup', arm); }
      window.OV_EXP = window.OV_EXP || {}; window.OV_EXP.signup_offer = arm;
    }
    var incentiveEl = dlg.querySelector('[data-ov-signup-incentive]');
    if (arm === 'incentive' && incentiveEl) {
      incentiveEl.hidden = false;
      var ed = dlg.querySelector('[data-ov-signup-editorial]'); if (ed) ed.hidden = true;
      var tags = dlg.querySelector('[data-ov-signup-tags]'); if (tags) tags.value += ',offer-incentive';
    }

    var armed = false, shown = false, start = Date.now();
    function show(trigger) {
      if (shown || !armed) return;
      if ($$('dialog[open]').length) return;
      shown = true;
      if (desktop) {
        OV.openDialog(dlg);
      } else {
        /* Phones get a non-modal sheet at the bottom: it covers no content,
           locks no scroll and takes no focus (Google interstitial guidance,
           NN/g on popups; docs/research/CRO_RESEARCH.md 2.13). */
        dlg.classList.add('is-sheet');
        if (typeof dlg.show === 'function') dlg.show(); else dlg.setAttribute('open', '');
      }
      OV.track('newsletter_prompt_shown', { trigger: trigger, arm: arm, style: desktop ? 'modal' : 'sheet' });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dlg.open && dlg.classList.contains('is-sheet')) OV.closeDialog(dlg);
    });
    /* never on first load: arm after 12s of real time on page */
    setTimeout(function () { armed = true; }, 12000);
    var desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (desktop) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0 && Date.now() - start > 12000) show('exit_intent');
      });
    } else if (OV.template !== 'product') {
      /* never on a phone PDP: the sticky buy bar owns the bottom of the screen */
      window.addEventListener('scroll', function onS() {
        var depth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
        if (depth > 0.6 && (pv > 1 || Date.now() - start > 25000)) { show('scroll_depth'); if (shown) window.removeEventListener('scroll', onS); }
      }, { passive: true });
    }
    dlg.addEventListener('ov:closed', function () {
      if (!state.subscribed) { state.closedAt = Date.now(); OV.local.set(KEY, state); }
    });

    var form = dlg.querySelector('form');
    var msg = dlg.querySelector('[data-ov-signup-msg]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]'); busy(btn, true);
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          /* Shopify may answer with a bot challenge; hand over to a real POST. */
          if (/\/challenge/.test(r.url)) { form.submit(); return; }
          if (r.ok && /customer_posted=true/.test(r.url)) return true;
          throw new Error('That address was not accepted. Check it and try again.');
        })
        .then(function (ok) {
          if (ok === undefined) return;
          state.subscribed = true; OV.local.set(KEY, state);
          var code = incentiveEl && arm === 'incentive' ? incentiveEl.getAttribute('data-code') : '';
          msg.textContent = code ? 'You’re on the list. Your code: ' + code : 'You’re on the list. Thank you.';
          OV.track('newsletter_signup', { placement: 'modal', arm: arm });
          setTimeout(function () { OV.closeDialog(dlg); }, code ? 6000 : 1800);
        })
        .catch(function (err) { msg.textContent = err.message; })
        .then(function () { busy(btn, false); });
    });
  })();

  /* -------------------------------------------------- page events */
  if (OV.template === 'index') OV.track('view_home', {});
  if (OV.template === 'collection' && OV.context.list) {
    OV.track('view_collection', { collection: OV.context.list.handle, count: OV.context.list.count, tags: OV.context.list.tags || [] });
  }
  if (window.OV_EXP && !OV.session.get('ov:exp-sent')) {
    OV.session.set('ov:exp-sent', true);
    OV.track('experiment_exposure', { experiments: window.OV_EXP });
  }

  /* pair impressions (homepage module, pairs page, PDP) */
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var n = en.target.getAttribute('data-ov-pair');
        if (seen[n]) return; seen[n] = true; io.unobserve(en.target);
        OV.track('pair_viewed', { pair: n, placement: OV.template });
      });
    }, { threshold: 0.5 });
    $$('[data-ov-pair]').forEach(function (el) { io.observe(el); });
  }

  document.dispatchEvent(new CustomEvent('ov:ready'));
})();
